import Vue from 'vue';

export default async () => {
  Vue.config.performance = Boolean(process.env.APP_ENV === 'dev');
};
